import CustomerSetting from './customer-setting';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import type ClientTag from './client-tag';
import type Site from './site';
import type User from './user';

@JsonApiResource({
  type: 'customer',
})
export default class Customer extends BaseEntity {
  city: string = '';
  contactEmail: string = '';
  contactFax: string = '';
  contactName: string = '';
  contactPhone: string = '';
  invoiceSite: string = '';
  name: string = '';
  primaryAddress: string = '';
  payableToo?: string;
  paymentContact?: string;
  @JsonApiProperty({ resolver: Number }) paymentDue: number;
  paymentSubmit?: string;
  purchaseOrder?: string;
  secondaryAddress: string = '';
  state: string = '';
  zip: string = '';

  nextInv: number = 0;
  @JsonApiProperty({ resolver: Number }) customerSince?: number;
  @JsonApiProperty({ resolver: Number }) taxRate?: number;

  isInactive: boolean = false;

  @JsonApiRelationship('site') sites = new Array<Site>();

  @JsonApiRelationship('client-tag') clientTags = new Array<ClientTag>();
  @JsonApiRelationship('customer-setting') customerSetting = new CustomerSetting();
  @JsonApiRelationship('user') users = new Array<User>();
  constructor(
    id?: Customer['id'],
    city: Customer['city'] = '',
    contactEmail: Customer['contactEmail'] = '',
    contactFax: Customer['contactFax'] = '',
    contactName: Customer['contactName'] = '',
    contactPhone: Customer['contactPhone'] = '',
    invoiceSite: Customer['invoiceSite'] = '',
    name: Customer['name'] = '',
    primaryAddress: Customer['primaryAddress'] = '',
    secondaryAddress: Customer['secondaryAddress'] = '',
    state: Customer['state'] = '',
    zip: Customer['zip'] = '',
    nextInv: Customer['nextInv'] = 0,
    isInactive: Customer['isInactive'] = false,
    customerSetting: Customer['customerSetting'] = new CustomerSetting(),
    sites: Customer['sites'] = new Array<Site>(),
    clientTags: Customer['clientTags'] = new Array<ClientTag>(),
    users: Customer['users'] = new Array<User>(),
    payableToo?: Customer['payableToo'],
    paymentContact?: Customer['paymentContact'],
    paymentDue: Customer['paymentDue'] = 10,
    paymentSubmit?: Customer['paymentSubmit'],
    purchaseOrder?: Customer['purchaseOrder'],
    customerSince?: Customer['customerSince'],
    taxRate?: Customer['taxRate']
  ) {
    super();
    this.id = id;
    this.city = city;
    this.contactEmail = contactEmail;
    this.contactFax = contactFax;
    this.contactName = contactName;
    this.contactPhone = contactPhone;
    this.invoiceSite = invoiceSite;
    this.name = name;
    this.payableToo = payableToo;
    this.paymentContact = paymentContact;
    this.paymentDue = paymentDue;
    this.paymentSubmit = paymentSubmit;
    this.primaryAddress = primaryAddress;
    this.purchaseOrder = purchaseOrder;
    this.secondaryAddress = secondaryAddress;
    this.state = state;
    this.zip = zip;
    this.nextInv = nextInv;
    this.taxRate = taxRate;
    this.isInactive = isInactive;
    this.customerSetting = customerSetting;
    this.sites = sites;
    this.users = users;
    this.customerSince = customerSince;
    this.clientTags = clientTags;
  }
}
